import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import EventEmitter, { SHOW_POPUP_UPGRADE } from '../../../helpers/EventEmitter'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { formatVal } from './../../../helpers/value'
import classes from './index.module.scss'

export const Score = ({ score, prevScore, colorScore }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)

  const isIncrease = prevScore < score

  const disableNeedUpgrade = [USER_TYPE.STANDARD, USER_TYPE.LITE].includes(
    userType.userTypeId,
  )

  const onClick = (e) => {
    if (disableNeedUpgrade) {
      e.stopPropagation()
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  return (
    <Element
      className={classes.score}
      style={{
        color: '#3A414B',
        backgroundColor: colorScore || '#BCBCBC',
      }}
      onClick={onClick}
    >
      {disableNeedUpgrade ? (
        <Icon className="icon-lock" color="#3A414B" />
      ) : (
        <>
          <span>{formatVal(score, locale, false, 0)}</span>
          {!isNaN(score) && !isNaN(prevScore) && prevScore !== score && (
            <Icon
              className="icon-north-east"
              style={{
                color: '#3A414B',
                fontSize: 13,
                transform: !isIncrease ? 'rotate(90deg)' : '',
              }}
            />
          )}
        </>
      )}
    </Element>
  )
}
